import { useState } from 'react';
import styled from 'styled-components';
import retangle from '../Media/Rectangle.png';
import ferramenta_baixar_story_img1 from '../Media/ferramenta-baixar-videos-img1.jpeg';
import ferramenta_baixar_story_img10 from '../Media/ferramenta-baixar-videos-img10.jpeg';
import ferramenta_baixar_story_img11 from '../Media/ferramenta-baixar-videos-img11.jpeg';
import ferramenta_baixar_story_img2 from '../Media/ferramenta-baixar-videos-img2.jpeg';
import ferramenta_baixar_story_img3 from '../Media/ferramenta-baixar-videos-img3.jpeg';
import ferramenta_baixar_story_img4 from '../Media/ferramenta-baixar-videos-img4.jpeg';
import ferramenta_baixar_story_img5 from '../Media/ferramenta-baixar-videos-img5.jpeg';
import ferramenta_baixar_story_img6 from '../Media/ferramenta-baixar-videos-img6.jpeg';
import ferramenta_baixar_story_img7 from '../Media/ferramenta-baixar-videos-img7.jpeg';
import ferramenta_baixar_story_img8 from '../Media/ferramenta-baixar-videos-img8.jpeg';
import ferramenta_baixar_story_img9 from '../Media/ferramenta-baixar-videos-img9.jpeg';
import LoadingAnimation from './LoadingAnimation';
import './Styles/story.css';

import AliceCarousel from 'react-alice-carousel';
import { Helmet } from 'react-helmet';
import { Carousel } from 'react-responsive-carousel';
import { api } from '../server/api';
import Header from './Header/Header';
import { HeaderMenu } from './HeaderMenu';
import LoadedPostDown from './LoadedResponses/LoadedPost';
import { Tools } from './Tools';
import { Faq } from './Tools/Faq';

const Story = (props) => {
  const [userId, setUserId] = useState('');
  const [responseObj, setResponseObj] = useState({});
  const [image, setImage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  // const [storyArray, setStoryArray] = useState([]);

  function submitHandler(e) {
    e.preventDefault();
    if (userId.length === 0) {
      alert('@Perfil vazio!');
      return (
        <div className="error-page">
          <h2>Nenhum story encontrado!</h2>
          <p>Veja se você digitou o @perfil corretamente.</p>
        </div>
      );
    }
    setIsLoading(true);
    fetchProfile();
  }

  function onChangehandler(e) {
    setUserId(e.target.value);
  }
  const items = [
    {
      question: 'O que é preciso fazer para baixar o Story do Instagram?',
      answer:
        '  Para que o processo de baixar Story funcione, tanto no PC quanto no smartphone, o seu perfil no Instagram precisa estar aberto. Caso contrário, pode acontecer algum problema, impedindo que o download seja feito.',
    },
    {
      question:
        'É preciso instalar o ImpulsioneGram no telefone ou no computador para baixar story do Instagram?',
      answer:
        ' Não. Baixar Story com a funcionalidade não tem complicações, como instalação de aplicativo ou preenchimento de cadastro. Tudo acontece de forma online e rápida, acompanhando a dinâmica da vida moderna.',
    },
    {
      question: 'O proprietário do story vai saber que baixei o conteúdo dela?',
      answer:
        'O ImpulsioneGram preza por 100% de segurança e privacidade no processo de baixar Stories. Então, não é preciso se preocupar, nem o proprietário e nem ninguém vai saber que você baixou determinado  conteúdo.',
    },
  ];
  const responsive = {
    1200: {
      items: 3,
    },
    800: {
      items: 3,
    },
    500: {
      items: 2,
    },
    0: {
      items: 1,
    },
  };

  const itemsResponsive = [
    <div className=" carrossel-item p-4  item-tools" data-value="1">
      <h3 className="text-color-black">1.MARKETING DE CONTEÚDO</h3>
      <p>
        Com a estratégia de marketing de conteúdo, você pode construir uma
        grande audiência no Instagram Stories para, posteriormente, monetizá-la,
        oferecendo produtos ou serviços.
      </p>

      <p>
        A funcionalidade permite você compartilhar conteúdos mais profundos, que
        envolvem os seguidores, agregando valor para suas vidas de algum modo.
        Assim, você só precisa direcionar sua comunicação para um público e
        produzir conteúdos que o ajude a resolver:
      </p>
      <p>
        <strong>Medos | Necessidades | Problemas | Desejos.</strong>
      </p>
    </div>,
    <div className=" p-4  item-tools" data-value="2">
      <h3>2. PARCERIAS</h3>
      <p>
        À medida que você constrói uma boa audiência no Instagram para
        determinado nicho, pode transformá-la em dinheiro fechando parcerias com
        profissionais e empresas do mesmo campo de atuação.
      </p>
      <p>
        Você pode, por exemplo, divulgar os produtos ou serviços da marca para o
        seu público e, a cada venda realizada, receber uma comissão pelos seus
        esforços em comercializar o item em questão.
      </p>
    </div>,
    <div className=" p-4  item-tools" data-value="3">
      <h3>3. ANÚNCIO DE PRODUTOS</h3>
      <p>
        Por meio do Instagram ads, é possível fazer anúncios da rede social.
        Inclusive, nos Stories. Com isso, você pode, por exemplo, comprar uma
        boa quantia de camisetas e divulgá-las na funcionalidade, formando assim
        um negócio online promissor.
      </p>
    </div>,
  ];
  async function fetchProfile() {
    const id = userId;
    try {
      const { data } = await api.get(`story/${id}`, {
        headers: {
          token:
            'dcbbf9d1dd87939fdcf446d5fef2f8ec0ea4382cd4f51bc462211bf7ba83fd47',
        },
      });

      setResponseObj(data);
      setIsLoading(false);
      setHasLoaded(true);
    } catch (error) {
      console.log('🚀 ~ file: Video.jsx:85 ~ fetchPost ~ error:', error);
    }
  }

  return (
    <>
      <Helmet>
        <title>Baixar Story Instagram Grátis Online e Rápido [2023]</title>
        <meta
          content="Apesar de não ser possível baixar vídeo Instagram por opção nativa, você ainda pode guardar conteúdos neste formato em seu dispositivo. Saiba como!"
          name="description"
        />
      </Helmet>

      <Header />
      <div className="reel-response">
        {isLoading && <LoadingAnimation />}
        {hasLoaded && <LoadedPostDown responseObj={responseObj} />}
      </div>
      <section id="story-section">
        <HeaderMenu
          submitHandler={submitHandler}
          onChangehandler={onChangehandler}
          description={
            'Insira abaixo o @perfil do usuário do reels escolhido e faça o download de forma online e gratuita.'
          }
          text_description={'BAIXE STORY DO INSTAGRAM'}
          placeholder={'Digite o link do @perfil'}
        />
      </section>

      <div className="background-white   py-5 color-grey-700">
        <div className="col-12 d-md-flex container">
          <div className="col-md-7 col-12">
            <div className="container text-left">
              <h1 className="text-center pb-5">
                Baixar Story do Instagram Grátis Online e Rápido [2023]
              </h1>
              <p>
                Se você já tentou <strong>baixar Story</strong> no{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/instagram-guia-completo/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Instagram
                </a>
                , sabe que o máximo que dá para fazer é tirar um print da tela.
                Uma vez que, a rede social não tem nenhuma função assim em seus
                diferentes tipos de publicação. Contudo, ainda é possível salvar
                seus Stories favoritos através de
                <a
                  href="https://www.impulsionegram.com.br/blog/automacao-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  ferramentas de terceiros
                </a>
                .
              </p>

              <p>
                Stories é uma das funcionalidades mais aclamadas do Instagram.
                Isso porque, você pode criar uma relação mais próxima com o
                público, conversando sobre assuntos que envolvem o dia a dia dos
                seus seguidores.
              </p>

              <p>
                Assim, o público fica mais{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/engajamento-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  engajado
                </a>{' '}
                e confiante na proposta do perfil, de modo que potencializam
                seus resultados na plataforma. Seja você
                <a
                  href="https://www.impulsionegram.com.br/blog/social-media/"
                  target="_blank"
                  rel="noreferrer"
                >
                  profissional
                </a>
                , empreendedor ou influenciador.
              </p>

              <p>
                Só que, às vezes, você entra ali no Instagram somente para
                consumir bons conteúdos, não é? Olhando postagens de algumas
                referências para ampliar seus conhecimentos, por exemplo.
              </p>

              <p>
                Nesta{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/saber-quem-visitou-perfil-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  visita a outros perfis
                </a>
                , pode acontecer de você encontrar uma ideia inovadora ou lições
                que precisa salvar em seu dispositivo a todo custo por conta de
                sua importância para alguma área da sua vida.
              </p>

              <p>
                Daí surge o seguinte dilema: não há como baixar Story de maneira
                nativa na rede social. O que, provavelmente, vai deixá-lo
                frustrado por não conseguir fazer o download daquele conteúdo
                tão valioso.
              </p>

              <p>
                Para isso, existe uma ferramenta do ImpulsioneGram feita para
                ajudá-lo a lidar com esse contratempo, permitindo você baixar
                quantos Stories quiser de forma online, grátis e rápida. Veja
                como usá-la no
                <a
                  href="https://www.impulsionegram.com.br/blog/postar-foto-instagram-pc/"
                  target="_blank"
                  rel="noreferrer"
                >
                  PC
                </a>{' '}
                e smartphone!
              </p>

              <p>Boa leitura!</p>
            </div>
          </div>
          <div className="col-md-5 col-12">
            <img
              className=" img-fluid img-responsive"
              src={retangle}
              alt="publicação instagram ícone três pontos topo lateral direita"
              width={'auto'}
            />
          </div>
        </div>

        <div className="  background-gray">
          <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_story_img1}
                    alt="seta apontando para nome do usuário Instagram"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h4 className="pb-3">1. Copie o nome do usuário</h4>

              <p>
                Primeiramente, você deve copiar o nome de usuário do perfil em
                que quer baixar Story, por meio da versão para desktop do
                Instagram. O processo é bem simples: basta abrir o perfil em
                questão, clicar na barra de endereço do navegador e usar os
                seguintes atalhos: Ctrl+A e Ctrl+C.
              </p>

              <h4 className="pb-3">
                2. Vá no site das ferramentas do ImpulsioneGram
              </h4>

              <p>
                Feito isso, você já pode acessar o site das ferramentas do
                ImpulsioneGram. É só ir para o começo desta página que você vai
                encontrá-la para continuar o processo de baixar Story.
              </p>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">3. Selecione “Story”</h4>

            <p>
              Na página inicial das ferramentas do ImpulsioneGram, perceba que
              várias opções aparecem na sua tela. Neste caso, você deve
              selecionar “Story” para continuar o processo de baixá-lo.
            </p>

            <h4 className="pb-3">4. Cole o nome do usuário</h4>

            <p>
              Em seguida, é hora de você usar o nome do usuário que copiou para
              área de transferência do seu PC, colocando-o no campo que está
              descrito “Digite o @perfil”
            </p>

            <p>
              Ao fazer isso, a URL completa será copiada no campo e você deve
              apagá-la totalmente, com exceção do nome do usuário, deixando
              conforme a imagem abaixo.
            </p>

            <h4 className="pb-3">5. Faça o download do Story</h4>

            <p>
              Colocou o nome do usuário? Agora, clique em “Download”. Fazendo
              isso, todos os Stories disponíveis no dia em que você está
              realizando o processo para Baixar Story serão carregados na página
              da ferramenta.
            </p>

            <p>
              Você pode{' '}
              <a
                href="https://www.impulsionegram.com.br/blog/como-aumentar-visualizacoes-stories/"
                target="_blank"
                rel="noreferrer"
              >
                visualizar
              </a>{' '}
              qualquer um dos Stories ali mesmo e baixar aquele quiser clicando
              novamente em “Download”. Só que dessa vez, é o botão que fica
              abaixo de cada Story.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! O download vai começar e quanto estiver terminado o
              arquivo do Story, normalmente, vai para pasta “Download” do seu
              computador para você vê-lo ou até mesmo repostá-lo quando quiser
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img2}
                  alt="seta indicando ícone story ferramenta ImpulsioneGram"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img3}
                  alt="caixa de escrita para digitar nome do usuário"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img4}
                  alt="opção story selecionada com caixa de perfil preenchida e seta indicando botão de download"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img5}
                  alt="3 setas indicando 3 botões de download"
                />
              </div>
            </Carousel>
          </div>
        </div>
        <div className="background-gray py-5">
          <div className="container col-12 d-md-flex justify-content-center align-items-center">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_story_img6}
                    alt="print celular três pontinhos story Instagram"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_story_img7}
                    alt="seta apontando para copiar url do perfil"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar Story pelo smartphone?
              </h2>

              <h4 className="pb-3">1. Copie o nome do usuário</h4>

              <p>
                Para baixar Story pelo smartphone, assim como no processo do PC,
                você deve copiar o nome de usuário do perfil em que o Story a
                ser baixado está. Só que o processo funciona de modo diferente.
              </p>

              <p>
                Você precisa entrar no perfil em questão, clicar no ícone com
                três pontinhos e selecionar a opção “Copiar URL do perfil”. Só
                assim, é possível copiar o nome do usuário pelo smartphone.
              </p>

              <h4 className="pb-3">
                2. Vá no site das ferramentas do ImpulsioneGram
              </h4>

              <p>
                Com o nome do usuário copiado, o próximo passo será ir até o
                site das ferramentas do ImpulsioneGram. Para isso, basta você
                subir até o começo desta página.
              </p>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">3. Selecione “Story”</h4>

            <p>
              Feito isso, você estará na página inicial das ferramentas do
              ImpulsioneGram, com algumas opções disponíveis para escolher
              livremente. Para baixar Story, é preciso clicar em “Story” para
              continuar.
            </p>

            <h4 className="pb-3">4. Cole o nome do usuário</h4>

            <p>
              Sabe o link que você baixou no começo do processo para baixar
              Story? Então, é hora de colocá-lo no campo “Digite o @perfil”.
              Pressione o dedo em cima do campo de digitação, por pelo menos 2
              segundos, e clique em “Colar”.
            </p>

            <p>
              Neste caso, o{' '}
              <a
                href="https://www.impulsionegram.com.br/blog/como-colocar-link-whatsaap-intagram/"
                target="_blank"
                rel="noreferrer"
              >
                link
              </a>{' '}
              inteiro será copiado para o campo. Você, porém, deverá apagar
              tudo, exceto o nome do perfil, deixando conforme a imagem abaixo.
              Caso contrário, o processo não vai funcionar.
            </p>

            <h4 className="pb-3">5. Faça o download do Story</h4>

            <p>
              Colocando corretamente o nome do usuário no campo solicitado,
              clique em “Download”. Desse modo, todos os Stories do perfil em
              questão serão carregados na página das ferramentas do
              ImpulsioneGram.
            </p>

            <p>
              Você pode visualizar os Stories disponíveis, escolhendo quais
              deles vai salvar no seu dispositivo, e baixá-los clicando
              novamente na opção “Download”. Dessa vez, no entanto, o botão fica
              abaixo de cada Story.
            </p>

            <h4 className="pb-3">6. Pronto</h4>

            <p>
              Pronto! O download do Story vai começar e quando estiver
              finalizado vai aparecer, provavelmente, na pasta “Download” do seu
              celular para você revê-lo, compartilhar com amigos ou repostá-lo
              na rede social.
            </p>

            <p>
              Para que o processo de baixar Story funcione, tanto no PC quanto
              no smartphone, o seu perfil no Instagram precisa estar aberto.
              Caso contrário, pode acontecer algum problema, impedindo que o
              download seja feito.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img8}
                  alt="print tela celular com seta indicando para ícone de story"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img9}
                  alt="area para digitar nome do usuário em destaque"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img10}
                  alt="opção story selecionada com seta apontando para download ao lado da caixa de texto"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_story_img11}
                  alt="seta apontando para botão de download em destaque"
                />
              </div>
            </Carousel>
          </div>
        </div>
      </div>

      <div class="cta-section footer-cta py-24 bg-pattern pattern-3 ">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-9 col-lg-10 col-xl-10">
              <div class="text-center dark-mode-texts">
                <h2 class="gr-text-2 mb-12">
                  COMO CONSEGUIR RENDA USANDO O STORY?
                </h2>{' '}
                <p class="text-white mb-0 mt-6">
                  Muitos não sabem disso, mas o Instagram Stories é uma ótima
                  forma de obter uma ótima renda extra. Inclusive, há
                  profissionais e empresas que faturam milhares e milhares
                  atráves da funcionalidade. Entre os principais meios para
                  conseguir renda usando o Story, destacam-se:
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <AliceCarousel
          // disableButtonsControls={true}
          disableDotsControls={true}
          mouseTracking
          items={itemsResponsive}
          responsive={responsive}
          controlsStrategy="alternate"
        />
      </div>

      <Tools name_tool={'stories'} />
      <div className="background-white">
        <Faq
          title={'DÚVIDAS COMUNS RELACIONADAS A BAIXAR FOTOS DO INSTAGRAM'}
          questions={items}
        />
      </div>
      <div className="container my-5 simple-download">
        <h3 className="mb-4 text-center">
          ImpulsioneGram: baixe quantos Stories quiser com a nossa ferramenta!
        </h3>
        <div className="col-md-9 col-12 m-auto">
          <p>
            Aprendeu a <strong>baixar Story</strong> no Instagram? É muito mais
            simples do que você imaginava, não é? Então, não perca mais tempo.
            Comece a baixar seus Stories favoritos o quanto antes.
          </p>

          <p>
            Pode ser em formato de vídeo, texto, imagem, não importa. Com essa
            ferramenta do ImpulsioneGram você pode fazer o download de quantos
            Stories quiser com poucos cliques.
          </p>

          <p>
            E o melhor: é 100% gratuito. Isso mesmo, você não vai precisar pagar
            absolutamente nada para guardar aqueles conteúdos valiosos no seu PC
            ou Smartphone. Suba para o início da página para acessar agora essa
            excelente ferramenta.
          </p>
        </div>
      </div>
    </>
  );
};

const Head = styled.div`
  font-size: 36px;
  text-align: center;
  margin-top: 18%;
  font-weight: bold;
  border-top: 1px solid #000;
  background: linear-gradient(
    45deg,
    #f09433 0%,
    #e6683c 25%,
    #dc2743 50%,
    #cc2366 75%,
    #bc1888 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Image = styled.img`
  max-width: 600px !important;
  height: auto;
`;

const Content = styled.div`
  padding: 10px;
`;

const Heading = styled.div`
  font-size: 32px;
  font-weight: bolder;
  text-align: center;
`;
const Para = styled.div`
  font-size: 20px;
  letter-spacing: 2px;
  margin-top: 30px !important;
  padding: 40px;
  background: linear-gradient(
    45deg,
    #f09433 0%,
    #e6683c 25%,
    #dc2743 50%,
    #cc2366 75%,
    #bc1888 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  text-shadow: 2px 0 #e6683c;
`;
export default Story;
